import { SignupState, SignupActionTypes, SignupSteps } from 'interfaces'

type Action =
  | { type: SignupActionTypes.SET_ERROR; payload: string }
  | { type: SignupActionTypes.SET_LOADER; payload: boolean }
  | { type: SignupActionTypes.SET_STEP; payload: SignupSteps }
  | { type: SignupActionTypes.SET_CODE_SENT; payload: boolean }
  | { type: SignupActionTypes.SET_EMAIL; payload: string }
  | { type: SignupActionTypes.SET_PHONE; payload: string }
  | { type: SignupActionTypes.SET_VALIDATING_USERNAME; payload: boolean }
  | { type: SignupActionTypes.SET_DISCORD_INVITE; payload: string }
  | { type: SignupActionTypes.SET_SHOW_RETURNED_USER_MODAL; payload: boolean }
  | { type: SignupActionTypes.SET_VALIDATING_EMAIL; payload: boolean }
  | {
      type: SignupActionTypes.SET_SINGUP_ERRORS
      payload: { [key: string]: boolean }
    }

export const signupReducer = (
  state: SignupState,
  action: Action
): SignupState => {
  switch (action.type) {
    case SignupActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case SignupActionTypes.SET_LOADER:
      return {
        ...state,
        loading: action.payload,
      }

    case SignupActionTypes.SET_STEP:
      return {
        ...state,
        step: action.payload,
      }

    case SignupActionTypes.SET_CODE_SENT:
      return {
        ...state,
        codeSent: action.payload,
      }

    case SignupActionTypes.SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      }

    case SignupActionTypes.SET_PHONE:
      return {
        ...state,
        phone: action.payload,
      }

    case SignupActionTypes.SET_VALIDATING_USERNAME:
      return {
        ...state,
        validatingExistingUsername: action.payload,
      }

    case SignupActionTypes.SET_DISCORD_INVITE:
      return {
        ...state,
        discordUrl: action.payload,
      }

    case SignupActionTypes.SET_SHOW_RETURNED_USER_MODAL:
      return {
        ...state,
        showReturnedUserModal: action.payload,
      }
    case SignupActionTypes.SET_VALIDATING_EMAIL:
      return {
        ...state,
        validatingExistingEmail: action.payload,
      }

    case SignupActionTypes.SET_SINGUP_ERRORS:
      return {
        ...state,
        singupErrors: {
          ...state.singupErrors,
          ...action.payload,
        },
      }

    default:
      return state
  }
}
